<template>
  <div class="container">
    <div class="drawer-content">
      <div class="info-list">
        <div class="info-content">
          <h1 class="customer-contact-title">
            {{ selectCustomerContact.name ? selectCustomerContact.name : '左侧列表选择联系人' }}
          </h1>
          <div class="info">
            <div class="basic-purview">
              <div
                class="basic-info-wrap"
              >
                <div class="title-wrap">
                  <h3>基础信息</h3>
                  <div
                    v-if="selectCustomerContact.name"
                    style="color: #858585; cursor: pointer"
                    @click="$refs.EditCustomerContactDrawer.openDrawer(selectCustomerContact)"
                  >
                    编辑
                  </div>
                </div>
                <div class="basic-info">
                  <div class="basic-info-left">
                    <CustomerBasicInfoRow
                      field="姓名"
                      :value="selectCustomerContact.name"
                      :type="'string'"
                    />
                    <CustomerBasicInfoRow
                      field="手机"
                      :value="selectCustomerContact.mobile"
                      :type="'string'"
                    />
                    <CustomerBasicInfoRow
                      field="客户"
                      :value="selectCustomerContact.customer ? selectCustomerContact.customer.map(x=> x.name).join(',') : '' "
                      :type="'string'"
                    />
                    <CustomerBasicInfoRow
                      field="部门"
                      :value="selectCustomerContact.department"
                      :type="'string'"
                    />
                    <CustomerBasicInfoRow
                      field="头衔"
                      :value="selectCustomerContact.title"
                      :type="'string'"
                    />
                    <CustomerBasicInfoRow
                      field="之前工作"
                      :value="selectCustomerContact.historyWorkInCustomer"
                      :type="'string'"
                    />
                    <CustomerBasicInfoRow
                      field="备注"
                      :value="selectCustomerContact.remark"
                      :type="'string'"
                    />
                  </div>
                  <div class="basic-info-right">
                    <CustomerBasicInfoRow
                      field="支付方式"
                      :value="paymentMethodToTextMethod(selectCustomerContact.paymentMethod)"
                      :type="'string'"
                    />
                    <CustomerBasicInfoRow
                      field="微信账号"
                      :value="selectCustomerContact.wechatAccount"
                      :type="'string'"
                    />
                    <CustomerBasicInfoRow
                      field="银行回款名"
                      :value="selectCustomerContact.bankRecieverName"
                      :type="'string'"
                    />
                    <CustomerBasicInfoRow
                      field="银行账号"
                      :value="selectCustomerContact.bankAccount"
                      :type="'string'"
                    />
                    <CustomerBasicInfoRow
                      field="银行"
                      :value="selectCustomerContact.bank"
                      :type="'string'"
                    />
                    <CustomerBasicInfoRow
                      field="支付宝账号"
                      :value="selectCustomerContact.alipayAccount"
                      :type="'string'"
                    />
                  </div>
                </div>
              </div>
              <!-- <div
                class="purview-info"
                v-if="isShowPurview"
              >
                <div class="title-wrap">
                  <h3>权限与状态</h3>
                  <div
                    style="color: #858585; cursor: pointer"
                    @click="
                      $refs.EditCustomerPurviewDrawer.openDrawer(customer)
                    "
                  >
                    编辑
                  </div>
                </div>
                <div class="basic-info">
                  <CustomerBasicInfoRow
                    field="所属部门"
                    :value="customer.department"
                    :type="'object'"
                  />
                  <CustomerBasicInfoRow
                    field="开发人员"
                    :value="customer.devSales"
                    :type="'array'"
                  />
                  <CustomerBasicInfoRow
                    field="维护人员"
                    :value="customer.maintainSales"
                    :type="'array'"
                  />
                  <CustomerBasicInfoRow
                    field="回款人员"
                    :value="customer.paymentSales"
                    :type="'array'"
                  />
                  <CustomerBasicInfoRow
                    field="销售可见"
                    :value="customer.salesVisibleMember"
                    :type="'array'"
                  />
                  <CustomerBasicInfoRow
                    field="技术可见"
                    :value="customer.techVisibleMember"
                    :type="'array'"
                  />
                  <CustomerBasicInfoRow
                    field="评分"
                    :value="customer.rating"
                    :type="'string'"
                  />
                  <CustomerBasicInfoRow
                    field="状态"
                    :value="customer.status"
                    :type="'status'"
                  />
                  <CustomerBasicInfoRow
                    field="允许开发"
                    :value="customer.openForDev"
                    :type="'dev'"
                  />
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <EditCustomerContactDrawer ref="EditCustomerContactDrawer" />
    <!-- <EditCustomerPurviewDrawer ref="EditCustomerPurviewDrawer" /> -->
  </div>
</template>

<script>
import dayjs from "dayjs";
import { mapActions, mapGetters, mapState } from "vuex";
import CustomerBasicInfoRow from "@/components/CustomerBasicInfoRow.vue";
import EditCustomerContactDrawer from "./EditCustomerContactDrawer.vue";
// import EditCustomerPurviewDrawer from "./EditCustomerPurviewDrawer";
import { arrayIntersection } from "@/utils";

const paymentMethodToText = {
  wechat: "微信",
  bankTransfer: "银行转账",
  alipay: "支付宝",
  cash: "现金",
};
export default {
  name: "CustomerContactInfo",
  components: {
    CustomerBasicInfoRow,
    EditCustomerContactDrawer,
    // EditCustomerPurviewDrawer,
  },
  data() {
    return {
      drawerOpened: false,
      tagsList: [
        {
          value: "搅拌站",
          label: "搅拌站",
        },
        {
          value: "管桩",
          label: "管桩",
        },
        {
          value: "构件",
          label: "构件",
        },
        {
          value: "管道",
          label: "管道",
        },
        {
          value: "水泥制品",
          label: "水泥制品",
        },
        {
          value: "中铁",
          label: "中铁",
        },
        {
          value: "中建",
          label: "中建",
        },
        {
          value: "中交",
          label: "中交",
        },
      ],
      // isShowPurview: true,
    };
  },
  methods: {
    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    paymentMethodToTextMethod(data) {
      return paymentMethodToText[data]
    },
  },
  async mounted() {
  },
  computed: {
    ...mapState({
      selectCustomerContact: (state) => state.customerContact.selectCustomerContact,
      customerContactList: (state) => state.customerContact.customerContactList,
    }),
  },
};
</script>

<style scoped lang="stylus">
.drawer-content
  display flex
  padding 0

.container
  width 100%
  height 100%

.info-content
  width 80%
  min-width 1200px
  padding 16px

.basic-purview
  display flex
  align-items flex-start

.title-wrap
  display flex
  justify-content space-between
  margin-bottom 15px

.basic-info-wrap
  width 60%
  min-width 700px
  border 1px solid #c9c9c9
  padding 10px

  .basic-info
    display flex

    .basic-info-right
      margin-left 20px

.basic-info-left, .basic-info-right
  width 50%

.purview-info
  border 1px solid #c9c9c9
  width 30%
  min-width 350px
  padding 10px
  margin-left 30px
</style>